var _path = "";
var _staticPath = {
    local: 'https://op-wstatic.ncsoft.com',
    op: 'https://op-wstatic.ncsoft.com',
    rc: 'https://rc-wstatic.plaync.co.kr',
    live: 'https://wstatic-cdn.plaync.com'
};
var staticPath = (function() {
  var loc = location.href;

  var projectPath = '/promo/aion/history/2021/210407_update/';
  _path = _staticPath.live + projectPath;

  if (/rc-/i.test(loc)) {
      _path = _staticPath.rc + projectPath;
  }
  if (/op\./i.test(loc)) {
      _path = _staticPath.op + projectPath;
  }
  if (/local\.|localhost|opdev|ui-static\.|file:/i.test(loc)) {
    _path = _staticPath.local + projectPath;
  }
})();

!function (e) {
  var a = {};
  function o(t) {
      if (a[t]) return a[t].exports;
      var r = a[t] = { i: t, l: !1, exports: {}};
      return e[t].call(r.exports, r, r.exports, o),
      r.l = !0,
      r.exports
  }
  o.m = e,
  o.c = a,
  o.d = function (e, a, t) {
      o.o(e, a) || Object.defineProperty(e, a, {
          configurable: !1,
          enumerable: !0,
          get: t
      })
  },
  o.n = function (e) {
      var a = e && e.__esModule ? function () { return e.default } : function () { return e };
      return o.d(a, "a", a), a
  },
  o.o = function (e, a) {
      return Object.prototype.hasOwnProperty.call(e, a)
  },
  o.p = "",
  o(o.s = 0)
}([
  function () {
    promokit.page({
      cnb: true,
      el: '#container',
      type: 'basic',
      game: 'aion',
      footer: {
        theme: 'white'
      },
      remote: {
        title: '데바, 보물의 주인이<br>되다',
        home: true, 
        active:true, 
        template: `<ul>
                    <li><a href="#section-1">요새 보물방</a></li>
                    <li><a href="#section-2">보물방 입장 변화</a></li>
                    <li><a href="#section-3">용신장 장비</a></li>
                    <li><a href="#section-4">데바와 함께</a></li>
                  </ul>`
      },
      headerButton: {
        cookie: {
          type: 'year',
          key: 'AION_210407_update',
          value: false
        },
        home: true,
        event: false,
        update: true,
        sns: true,
        theme: 'black'
      }
    });
    var ani_header = new TimelineMax({paused: !0,delay: "1.0"})
        .fromTo($(".tit-1"), 1.3, {y: 40, alpha: 0}, {y: 0,alpha: 1,ease: Power2.easeOut})
        .fromTo($(".tit-2"), 0.9, {scale: 1.2,alpha: 0}, {scale: 1, alpha: 1, ease: Power2.easeOut}, "-=.9")
        .fromTo($(".tit-3"), .5, {y: 50,alpha: 0}, {y: 0,alpha: 1,ease: Power2.easeOut}, "-=0.3")
        .fromTo($(".btn-scroll"), .5, {y: 5,alpha: 0}, {y: 0,alpha: 1,ease: Power2.easeOut}, "+=0.5")
        .fromTo($(".other"), .5, {y: 100,alpha: 0}, {y: 0,alpha: 1,ease: Power2.easeOut}, "-=0.1");


    var video_header = promokit.video({
        el: '#player1',
        url: 'https://vod.plaync.com/Aion/update/210407/ClassicUD_BG_low.mp4',
        controls: false,
        loop: true,
        autoplay: false,
        mute: true,
        preload: true,
        resizeTarget: 'window'
    });
          
    var image_viewer = [];
    $('.btn_viewer').each(function (i) {
      var viewer_id = $(this).data('viewer-open');
      $(this).data('idx',i);
      var ary = [];
      for(var i=0; i<$('#'+viewer_id + ' img').length; i++) {
        ary.push( {
          src: $('#'+viewer_id + ' img').eq(i).attr('src'),
          title : $('#'+viewer_id + ' img').eq(i).attr('alt')
        })
      }
      var viewer = promokit.viewer({
        images: ary
      });
      image_viewer.push(viewer);
      $(this).on('click', function() {
        image_viewer[$(this).data('idx')].open();
      })
    })

      promokit.preload({
          complete: function () {
            console.log('preload');
            video_header.on("play", function () {
              console.log('play')
                ani_header.play()
            });
            video_header.play()
          }
      });
      promokit.tab({
        el: '#tab-1',
        fade: true
      });

      //배너이미지 - 데바의 보물상자 보상받기
      $('.banner').append('<a href="https://aion.plaync.com/events/2021/210407_treasurebox?coupon=juergen" onclick="icast(\'AMTLD2I009VE\', \'track\', {\'pagename\' : \'classic_update\'});" target="_blank" border="0"><img src="'+_path+'img/pc/sec1_banner2.png"></a>');
      

      //  슬라이드 링크 및 이미지 
      var slide_txt = "";
      slide_txt += '<div class="li"><a href="https://aion.plaync.com/events/2021/210407_treasurebox"><img src="'+_path+'img/pc/banner-1.jpg"></a></div>'
      slide_txt += '<div class="li"><a href="https://aion.plaync.com/guidebook/classic/index"><img src="'+_path+'img/pc/banner-2.jpg"></a></div>'

      $('#slide').append(slide_txt);

      var slide1 = promokit.slide({
        el: '#slide',
        arrow: true,
        bullet: true
      });
      
      slide1.on('slidestart', ({to, now, prev}) => {
        $('.promokit-slide__button--prev').attr('disabled', to==0);
        $('.promokit-slide__button--next').attr('disabled', to == $('#slide .li').length-1);
      });
      $('.promokit-slide__button--prev').attr('disabled', true);


      $(".btn-scroll").on("click", function (e) {
          e.preventDefault(),
          $("html, body").animate({
              scrollTop: $($(this).attr("href")).offset().top
          }, 500, "linear")
      })

      $('.banner .btn_close').on('click', function() {
        $('.banner').fadeOut(300);
      })
      $(window).on('scroll', function() {
        if ($(window).scrollTop() > $('#section-1').offset().top) {
          if ($('.promokit-remote').css('opacity')==0 || $('.promokit-remote').css('display')=="none") {
            $('.promokit-remote').fadeIn(300);
          }
        }
        else {
          if ($('.promokit-remote').css('opacity')>0) {
            $('.promokit-remote').fadeOut(300);
          }
        }
      });
      
  }
]);



// WEBPACK FOOTER //
// ./src/js/index.js